module.exports = __webpack_public_path__ + "img/TyunzhenshiB.a93f136f.svg";